import { CaseReducer, PayloadAction, createSlice } from '@reduxjs/toolkit';

import { get } from 'api/requests';
import { loading } from 'store/common';

import { IReducer, AppThunk } from 'store/types';
import { IParamsReq } from 'types';
import { IDefect } from 'features/EngineeringNetStatus/types';

interface IDefectsState {
  loading: boolean;
  defects: IDefect[];
}

const initialState: IDefectsState = {
  loading: false,
  defects: [],
};

const reset: IReducer<IDefectsState, IDefectsState> = () => initialState;

const setDefects: CaseReducer<IDefectsState, PayloadAction<Array<IDefect>>> = (state, action) => {
  state.defects = action.payload;
};

export const defectsSlice = createSlice({
  name: 'MODAL/defects',
  initialState,
  reducers: {
    loading: loading as IReducer<IDefectsState, boolean>,
    setDefects,
    reset,
  },
});

const { loading: setLoading, setDefects: setDefectsData } = defectsSlice.actions;

export const getEngineeringDefects =
  (params: IParamsReq): AppThunk =>
  dispatch => {
    dispatch(setLoading(true));

    // TODO type
    get<IDefect[]>('/api/issues/en/', params)
      .then(({ data }) => {
        const { results } = data;
        dispatch(setDefectsData(results));
      })
      .finally(() => dispatch(setLoading(false)));
  };

export { setLoading };
